export const environments = {
  production: false,
  domain: 'http://localhost:4200',
  apiUrl: 'https://thevinaymalviya.org/api/',
  wsUrl: 'https://thevinaymalviya.org/ws',
  GOOGLE_CLIENT_ID: '81561226063-9p2ho349u5g34lrj3ep46r86s19m7ftq.apps.googleusercontent.com',
  cryptoTracksheetUrl:
    'https://docs.google.com/spreadsheets/d/1aoVITD41UaJcmxwSk1RUiM0k7jEKfRtMOd4YLBqIlVA/edit?gid=0#gid=0',
  forexTracksheetUrl:
    'https://docs.google.com/spreadsheets/d/1A1znuEvQjumyLiLZwrZSCvWAf_Vs8Xv_o83w1TPsTeM/edit?gid=0#gid=0',
};
